import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

export default function RouteGuard({ Component, notFound }) {
    const history = useHistory();

    useEffect(() => {
        if (!localStorage.getItem('token')) {
            history.push('/login');
        } else {
            if (notFound) {
                history.push('/admin/users');
            }
        }
        //eslint-disable-next-line
    }, []);

    return <Component />;
}